<template>
  <div class="page-container">
    <!-- ========== 头部区域 ========== -->
    <div class="header-section">
      <!-- 状态栏 -->
      <div class="status-bar">
        <div class="status-icons">
          <nut-icon name="bell" size="16" color="rgba(255,255,255,0.9)"></nut-icon>
        </div>
      </div>

      <!-- 用户卡片 -->
      <div class="user-card">
        <div class="avatar-wrapper">
          <div class="avatar-ring">
            <img :src="userAvatar" alt="头像" />
          </div>
          <div class="avatar-dot"></div>
        </div>
        <div class="user-info">
          <h2 class="user-name">{{ userName }}<span class="greeting">，{{ greeting }}</span></h2>
          <p class="user-dept">{{ userDept }}</p>
        </div>
        <div class="header-action" @click="toUser">
          <nut-icon name="my" size="20" color="rgba(255,255,255,0.8)"></nut-icon>
        </div>
      </div>

      <!-- 快捷数据概览 -->
      <div class="header-stats">
        <div class="stat-item">
          <span class="stat-num">{{ headerTodayApply }}</span>
          <span class="stat-label">今日申请</span>
        </div>
        <div class="stat-divider"></div>
        <div class="stat-item">
          <span class="stat-num">{{ headerTodayLoan }}</span>
          <span class="stat-label">今日放款</span>
        </div>
        <div class="stat-divider"></div>
        <div class="stat-item">
          <span class="stat-num">{{ headerMonthLoan }}</span>
          <span class="stat-label">本月放款</span>
        </div>
      </div>
    </div>

    <!-- ========== 内容区域 ========== -->
    <div class="content-wrapper">
      <!-- 切换 Tab -->
      <div class="switch-tabs">
        <button
          :class="['tab-btn', { active: currentTab === 'order' }]"
          @click="tabClick('order')"
        >订单总览</button>
        <button
          :class="['tab-btn', { active: currentTab === 'merchant' }]"
          @click="tabClick('merchant')"
        >商户总览</button>
      </div>
	  
	  <div v-if="currentTab === 'order'">
		  <!-- 今日数据 -->
		  <div class="data-card card-today">
		    <div class="card-header">
		      <div class="card-title-row">
		        <div class="card-icon icon-today">
		          <nut-icon name="date" size="18" color="#fff"></nut-icon>
		        </div>
		        <div>
		          <h3 class="card-title">今日数据</h3>
		          <p class="card-subtitle">{{ todayDate }}</p>
		        </div>
		      </div>
		    </div>
		    <div class="card-body">
		      <div class="data-row">
		        <div class="data-item">
		          <span class="data-label">申请笔数</span>
		          <span class="data-value">{{orderList.todayData.loanCount}}<small>笔</small></span>
		        </div>
		        <div class="data-item">
		          <span class="data-label">申请金额</span>
		          <span class="data-value">{{orderList.todayData.loanAmount}}<small>元</small></span>
		        </div>
		      </div>
		      <div class="data-divider"></div>
		      <div class="data-row">
		        <div class="data-item">
		          <span class="data-label">放款笔数</span>
		          <span class="data-value highlight-green">{{orderList.todayData.applicationCount}}<small>笔</small></span>
		        </div>
		        <div class="data-item">
		          <span class="data-label">放款金额</span>
		          <span class="data-value highlight-green">{{orderList.todayData.applicationAmount}}<small>元</small></span>
		        </div>
		      </div>
		    </div>
		  </div>
		  
		  <!-- 本月数据 -->
		  <div class="data-card card-month">
		    <div class="card-header">
		      <div class="card-title-row">
		        <div class="card-icon icon-month">
		          <nut-icon name="order" size="18" color="#fff"></nut-icon>
		        </div>
		        <div>
		          <h3 class="card-title">本月数据</h3>
		          <p class="card-subtitle">{{ monthDate }}</p>
		        </div>
		      </div>
		    </div>
		    <div class="card-body">
		      <div class="data-row">
		        <div class="data-item">
		          <span class="data-label">申请笔数</span>
		          <span class="data-value">{{orderList.monthData.loanCount}}<small>笔</small></span>
		        </div>
		        <div class="data-item">
		          <span class="data-label">申请金额</span>
		          <span class="data-value">{{orderList.monthData.loanAmount}}<small>元</small></span>
		        </div>
		      </div>
		      <div class="data-divider"></div>
		      <div class="data-row">
		        <div class="data-item">
		          <span class="data-label">放款笔数</span>
		          <span class="data-value highlight-green">{{orderList.monthData.applicationCount}}<small>笔</small></span>
		        </div>
		        <div class="data-item">
		          <span class="data-label">放款金额</span>
		          <span class="data-value highlight-green">{{orderList.monthData.applicationAmount}}<small>元</small></span>
		        </div>
		      </div>
		    </div>
		  </div>
	  </div>
	  <div v-else class="merchant-scroll">
		  <div class="data-card" v-for="item in merchantList">
			  <div class="card-header">
			    <div class="card-title-row">
			      <div class="card-icon icon-month">
			        <nut-icon name="order" size="18" color="#fff"></nut-icon>
			      </div>
			      <div>
			        <h3 class="card-title">{{item.merchantName}}</h3>
			        <p class="card-subtitle">{{ monthDate }}</p>
			      </div>
			    </div>
			  </div>
			  <div class="card-body">
			    <div class="data-row">
			      <div class="data-item">
			        <span class="data-label">今日申请笔数</span>
			        <span class="data-value">{{item.today.loanCount}}<small>笔</small></span>
			      </div>
			      <div class="data-item">
			        <span class="data-label">今日放款笔数</span>
			        <span class="data-value">{{item.today.applicationCount}}<small>元</small></span>
			      </div>
				  <div class="data-item">
				    <span class="data-label">今日放款金额</span>
				    <span class="data-value">{{item.today.applicationAmount}}<small>元</small></span>
				  </div>
			    </div>
			    <div class="data-divider"></div>
			    <div class="data-row">
			      <div class="data-item">
			        <span class="data-label">当月申请笔数</span>
			        <span class="data-value">{{item.month.loanCount}}<small>笔</small></span>
			      </div>
			      <div class="data-item">
			        <span class="data-label">当月放款笔数</span>
			        <span class="data-value">{{item.month.applicationCount}}<small>元</small></span>
			      </div>
			      <div class="data-item">
			        <span class="data-label">当月放款金额</span>
			        <span class="data-value">{{item.month.applicationAmount}}<small>元</small></span>
			      </div>
			    </div>
				<div class="data-divider"></div>
				<div class="data-row">
				  <div class="data-item">
				    <span class="data-label">年度申请笔数</span>
				    <span class="data-value">{{item.year.loanCount}}<small>笔</small></span>
				  </div>
				  <div class="data-item">
				    <span class="data-label">年度放款笔数</span>
				    <span class="data-value">{{item.year.applicationCount}}<small>元</small></span>
				  </div>
				  <div class="data-item">
				    <span class="data-label">年度放款金额</span>
				    <span class="data-value">{{item.year.applicationAmount}}<small>元</small></span>
				  </div>
				</div>
			  </div>
		  </div>
	  </div>

      
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance} from 'vue';
import { useRouter } from 'vue-router';
import { Toast } from '@nutui/nutui';

const router = useRouter();
const { proxy } = getCurrentInstance();

// 用户信息（从 localStorage 读取）
const userAvatar = ref('https://img12.360buyimg.com/imagetools/jfs/t1/196430/38/8105/14329/60c806a4Ed506298a/e6de9fb7b8490f38.png');
const userName = ref('');
const userDept = ref('');
let userData = {}

// 当前 Tab
const currentTab = ref('order');
const tabActive = ref(0);

const orderList = ref({
	todayData:{},
	monthData:{}
})
const merchantList = ref({})

// 问候语
const greeting = computed(() => {
  const h = new Date().getHours();
  if (h < 9) return '早上好';
  if (h < 12) return '上午好';
  if (h < 14) return '中午好';
  if (h < 18) return '下午好';
  return '晚上好';
});

// 头部快捷数据
const headerTodayApply = computed(() => orderList.value.todayData?.loanCount || 0);
const headerTodayLoan = computed(() => orderList.value.todayData?.applicationAmount || 0);
const headerMonthLoan = computed(() => orderList.value.monthData?.applicationAmount || 0);

// 时间
const currentTime = ref('');
const updateTime = () => {
  const now = new Date();
  currentTime.value = now.getHours().toString().padStart(2, '0') + ':' + now.getMinutes().toString().padStart(2, '0');
};

// 日期
const todayDate = computed(() => {
  const d = new Date();
  return d.getFullYear() + '.' + (d.getMonth() + 1).toString().padStart(2, '0') + '.' + d.getDate().toString().padStart(2, '0');
});
const monthDate = computed(() => {
  const d = new Date();
  return d.getFullYear() + '.' + (d.getMonth() + 1).toString().padStart(2, '0');
});

// 跳转
const toUser = () => router.push('/user');

// 初始化
onMounted(() => {
  updateTime();
  setInterval(updateTime, 60000);

  // 从 localStorage 读取用户信息
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
		userData = user
      userName.value = user.nickName || user.userName;
      userDept.value = user.deptName || user.dept?.deptName;
      if (user.avatar) userAvatar.value = user.avatar;
	  merchantStatistics()
		  overview()
    }
  } catch (e) {
    // ignore
  }
});

const tabClick = (type)=>{
	currentTab.value = type
	if(type == 'order'){
		overview()
	}else{
		merchantStatistics()
	}
}

const overview = ()=>{
	console.log(userData)
	proxy.$axios.overview(userData.userId).then(res=>{
		if(res.data.code == 200){
			orderList.value = res.data.data
			console.log(orderList.value)
		}else{
			Toast.fail(res.data.msg);
		}
	})
}

const merchantStatistics = ()=>{
	proxy.$axios.merchantStatistics(userData.userId).then(res=>{
		if(res.data.code == 200){
			merchantList.value = res.data.data
		}else{
			Toast.fail(res.data.msg);
		}
	})
}
</script>

<style scoped>
/* ========== 全局容器 ========== */
.page-container {
  min-height: 100vh;
  background-color: #f5f3f0;
  display: flex;
  flex-direction: column;
  padding-bottom: 60px;
}

/* ========== 头部区域 ========== */
.header-section {
  position: relative;
  background: linear-gradient(160deg, #3a3226 0%, #4a3f32 30%, #5c4e3d 60%, #4a3f32 100%);
  padding: 0 20px 55px;
  color: #fff;
  overflow: hidden;
}
/* 头部装饰 */
.header-section::before {
  content: '';
  position: absolute;
  top: -60px;
  right: -30px;
  width: 180px;
  height: 180px;
  background: rgba(197, 164, 126, 0.08);
  border-radius: 50%;
  pointer-events: none;
}
.header-section::after {
  content: '';
  position: absolute;
  bottom: 20px;
  left: -40px;
  width: 120px;
  height: 120px;
  background: rgba(197, 164, 126, 0.06);
  border-radius: 50%;
  pointer-events: none;
}

/* 状态栏 */
.status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 6px;
  font-size: 13px;
  position: relative;
  z-index: 2;
}
.status-bar .time {
  font-weight: 600;
  letter-spacing: 1px;
}

/* 用户卡片 */
.user-card {
  display: flex;
  align-items: center;
  padding: 10px 0 16px;
  position: relative;
  z-index: 2;
}
.avatar-wrapper {
  position: relative;
  margin-right: 14px;
}
.avatar-ring {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  padding: 2px;
  background: linear-gradient(135deg, #C5A47E, #8B7355);
  overflow: hidden;
}
.avatar-ring img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #3a3226;
}
.avatar-dot {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 10px;
  height: 10px;
  background: #4caf50;
  border-radius: 50%;
  border: 2px solid #3a3226;
}
.user-info {
  flex: 1;
}
.user-name {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 4px;
  letter-spacing: 0.5px;
  text-align: left;
}
.user-name .greeting {
  font-size: 15px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
}
.user-dept {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}
.user-dept::before {
  content: '';
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #C5A47E;
  border-radius: 50%;
}
.header-action {
  padding: 8px;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.2s;
}
.header-action:hover {
  opacity: 1;
}

/* 头部快捷数据 */
.header-stats {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 14px 8px;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 2;
}
.stat-item {
  text-align: center;
  flex: 1;
}
.stat-num {
  display: block;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 2px;
}
.stat-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
}
.stat-divider {
  width: 1px;
  height: 30px;
  background: rgba(255, 255, 255, 0.12);
}

/* ========== 内容区域 ========== */
.content-wrapper {
  margin-top: -30px;
  background-color: #f5f3f0;
  border-radius: 24px 24px 0 0;
  padding: 20px 18px 30px;
  flex: 1;
  position: relative;
  z-index: 10;
}
/* 商户滚动列表 */
.merchant-scroll {
    height: calc(100vh - 320px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}


/* 切换 Tabs */
.switch-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}
.tab-btn {
  flex: 1;
  height: 40px;
  border: none;
  border-radius: 20px;
  background: #fff;
  color: #999;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 1px;
}
.tab-btn.active {
  background: linear-gradient(135deg, #8B7355, #a89070);
  color: #fff;
  box-shadow: 0 4px 12px rgba(139, 115, 85, 0.3);
}

/* ========== 数据卡片 ========== */
.data-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  animation: fadeUp 0.5s ease-out;
}
.data-card:last-child {
  animation-delay: 0.1s;
}
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-header {
  margin-bottom: 16px;
}
.card-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.card-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-today {
  background: linear-gradient(135deg, #8B7355, #C5A47E);
}
.icon-month {
  background: linear-gradient(135deg, #6b8f71, #8faf95);
}
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 2px;
}
.card-subtitle {
  font-size: 12px;
  color: #bbb;
  margin: 0;
}

.card-body {
  background: #fafaf8;
  border-radius: 12px;
  padding: 12px 10px;
}
.data-row {
  display: flex;
  gap: 8px;
}
.data-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 0;
  text-align: center;
}
.data-label {
  font-size: 12px;
  color: #888;
  margin-bottom: 2px;
}
.data-value {
  font-size: 15px;
  font-weight: 700;
  color: #333;
}
.data-value small {
  font-size: 12px;
  font-weight: 400;
  color: #999;
  margin-left: 2px;
}
.data-value.highlight-green {
  color: #5a8a6a;
}
.data-divider {
  height: 1px;
  background: #f0ede8;
  margin: 2px 0;
}
</style>
